<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path fill-rule="evenodd" d="M8 5.761v5.58H6.3v-5.58H8zm0-2.943v1.956H6.3V2.818H8zM0 7c0 3.864 3.136 7 7 7s7-3.136 7-7-3.136-7-7-7-7 3.136-7 7z"/>
</svg>
